<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'addReturn'
}
</script>

<style>

</style>
